module.exports = __webpack_public_path__ + "img/alipay.559544e1.png";